const Menu = [
    { header: 'Nadzorna Plošča' },
    {
        name: 'dashboard',
        title: 'Pregled',
        icon: 'mdi-view-dashboard',
        path: '/pregled',
        group: 'dashboard',
        permissions: ['ps-demo'],
        top_level: true
    },
    
    {
        name: 'settings',
        title: 'Nastavitve',
        icon: 'mdi-cogs',
        path: '/nastavitve',
        group: 'settings',
        permissions: ['ps-demo'],
        top_level: true
    },
    
    
    
    {
        title: 'Uporabniki',
        icon: 'mdi-account-group',
        group:'uporabniki',
        permissions: ['ps-demo'],
        items: [
            {
                name: 'users_list',
                title: 'Seznam uporabnikov',
                icon: 'mdi-account-group',
                path: '/seznam-uporabnikov',
                group: 'users_list',
                permissions: ['ps-demo'],
                top_level: false
            },
            {
                name: 'add_user',
                title: 'Dodaj uporabnika',
                icon: 'mdi-account-plus',
                path: '/dodaj-uporabnika',
                group: 'add_user',
                permissions: ['ps-demo'],
                top_level: false
            },
        ]
    },
    
    /*
    {
        name: 'users_list',
        title: 'Seznam uporabnikov',
        icon: 'mdi-account-group',
        path: '/seznam-uporabnikov',
        group: 'users_list',
        permissions: ['ps-demo'],
        top_level: true
    },
    {
        name: 'add_user',
        title: 'Dodaj uporabnika',
        icon: 'mdi-account-plus',
        path: '/dodaj-uporabnika',
        group: 'add_user',
        permissions: ['ps-demo'],
        top_level: true
    },
    */

    {
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: '/zasedenost-parkirisca',
        group: 'parking_occupancy',
        permissions: ['ps-demo'],
        top_level: true
    },

    {
        name: 'registration-numbers',
        title: 'Enkratni prehodi',
        icon: 'mdi-car-side',
        path: 'enkratni-prehodi/registrske-stevilke',
        group: 'vehicles',
        permissions: ['ps-demo'],
        top_level: true
    },

    {
        name: 'validator',
        title: 'Validator',
        icon: 'mdi-barcode-scan',
        path: '/validacije',
        group: 'validator',
        permissions: ['ps-demo'],
        top_level: true
    },
    

    /*
    {
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: 'zasedenost-parkirisca',
        group: 'parking_occupancy',
        permissions: ['ps-demo'],
        top_level: true
    },
    */
    
    
    {
        title: 'Zapornice',
        icon: 'mdi-boom-gate',
        group: 'zapornice', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: ['ps-demo'],
        items: [
            {
                name: 'parking_barriers_management',
                title: 'Upravljanje zapornic',
                icon: 'mdi-android-messages',
                path: '/zapornice/upravljanje',
                permissions: ['ps-demo'],
            },

            {
                name: 'parking_barriers_timeline',
                title: 'Časovnica',
                icon: 'mdi-android-messages',
                path: '/zapornice/casovnica',
                permissions: ['ps-demo'],
            },
            
            {
                name: 'parking_barriers_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/zapornice/arhiv',
                permissions: ['ps-demo'],
            }
        ]
    },

    // POTOPNI STEBRIČKI
    {
        title: 'Potopni stebrički',
        icon: 'mdi-pillar',
        group: 'potopni-stebricki', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: ['ps-demo'],
        items: [
            {
                name: 'bollards_management',
                title: 'Upravljanje stebričkov',
                icon: 'mdi-android-messages',
                path: '/potopni-stebricki/upravljanje',
                permissions: ['ps-demo'],
            },

            {
                name: 'bollards_timeline',
                title: 'Časovnica',
                icon: 'mdi-android-messages',
                path: '/bollards/casovnica',
                permissions: ['ps-demo'],
            },
            
            {
                name: 'bollards_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/potopni-stebricki/arhiv',
                permissions: ['ps-demo'],
            }
        ]
    },

    {
        title: 'Križne zapore',
        icon: 'mdi-turnstile',
        group: 'krizne-zapore', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: ['ps-demo'],
        items: [
            {
                name: 'turnstiles_management',
                title: 'Upravljanje križnih zapor',
                icon: 'mdi-android-messages',
                path: '/krizne-zapore/upravljanje',
                permissions: ['ps-demo']
            },
            {
                name: 'turnstile_timeline',
                title: 'Časovnica',
                icon: 'mdi-android-messages',
                path: '/krizne-zapore/casovnica',
                permissions: ['ps-demo'],
            },
            {
                name: 'turnstiles_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/krizne-zapore/arhiv',
                permissions: ['ps-demo'],
            }
        ]
    },

    {
        name: 'exports',
        title: 'Izvoz podatkov',
        icon: 'mdi-application-export',
        path: 'izvoz-podatkov',
        group: 'exports',
        permissions: ['ps-demo'],
        top_level: true
    },
    
]

export { Menu }